import PropTypes from 'prop-types';
import Image from 'next/image';
import { Box } from '@mui/material';

/**
 * next/image wrapper for CMS marketing sections.
 * Parent Box is position:relative by default; callers size it via sx
 * (width/height/aspectRatio or absolute inset). objectFit goes on the Image.
 */
export default function MarketingSectionImage({
  src,
  alt = '',
  sizes,
  quality = 70,
  priority = false,
  sx,
  objectFit = 'cover',
  objectPosition,
}) {
  if (!src) return null;

  return (
    <Box
      sx={{
        position: 'relative',
        overflow: 'hidden',
        ...sx,
      }}
    >
      <Image
        src={src}
        alt={alt}
        fill
        sizes={sizes}
        quality={quality}
        priority={priority}
        style={{
          objectFit,
          ...(objectPosition ? { objectPosition } : {}),
        }}
      />
    </Box>
  );
}

MarketingSectionImage.propTypes = {
  src: PropTypes.string,
  alt: PropTypes.string,
  sizes: PropTypes.string.isRequired,
  quality: PropTypes.number,
  priority: PropTypes.bool,
  sx: PropTypes.oneOfType([PropTypes.object, PropTypes.array, PropTypes.func]),
  objectFit: PropTypes.string,
  objectPosition: PropTypes.string,
};
